import { DesignData, MediaAddon } from 'src/store/design/types';

interface AddonCounter {
  clipArtId: string; // Changed to string to support UUIDs
  quantity: number;
}

interface ClipArtUsageData {
  [key: string]: {
    clipArtId: string;
    quantity: number;
  };
}

const collectAllUsedAddons = (design: DesignData) => {
  const usedAddons: ClipArtUsageData = {};
  design.spreads.forEach((spread) => {
    if (spread.pages[0] && spread.pages[0].groups && spread.pages[0].groups.media) {
      spread.pages[0].groups.media.forEach((element) => {
        if (element.type === 'addon') {
          const { addonId } = (element as MediaAddon);
          if (usedAddons[addonId]) {
            usedAddons[addonId].quantity += 1;
          } else {
            usedAddons[addonId] = {
              clipArtId: String(addonId), // Convert to string to support both numeric IDs and UUIDs
              quantity: 1,
            };
          }
        }
      });
    }
  });
  return (Object.values(usedAddons) as AddonCounter[]);
};

export default collectAllUsedAddons;
